import ManualLinkSetup from '@monetr/interface/components/setup/manual/ManualLinkSetup';

export default function CreateManualLinkPage(): React.JSX.Element {
  return <ManualLinkSetup />;
}
